import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel, EdriveSharedAuthModel } from '../../_models/auth.model';
import { UsersTable } from 'src/app/_fake/fake-db/users.table';
import { SharedUserModel } from '../../_models/shared-user.model';

const API_USERS_URL = `${environment.apiUrl}/auth`;
const EDRIVE_SHARED_API_URL = `${environment.ApiUrl}/shared-items/shared-url/pb`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }

  // public methods
  edrive_shared_login(key: string, password: string): Observable<any> {
    return this.http.post<EdriveSharedAuthModel>(`${EDRIVE_SHARED_API_URL}/login`, { key, password });
  } 

  check_edrive_shared_key(key: string) : Observable<any> {
    return this.http.get<any>(`${EDRIVE_SHARED_API_URL}/validation?key=` + key);
  }

  // public methods
  login(email: string, password: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/login`, { email, password });
  }
  
  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/forgot-password`, {
      email,
    });
  }

  getUserByToken(token): Observable<UserModel> {
    // const httpHeaders = new HttpHeaders({
    //   Authorization: `Bearer ${token}`,
    // });
    // return this.http.get<UserModel>(`${API_USERS_URL}/me`, {
    //   headers: httpHeaders,
    // });
    const user = UsersTable.users.find((u) => {
      return u.authToken === token;
    });

    if (!user) {
      return of(undefined);
    }

    return of(user);
  }

  createSharedUser(auth:any): Observable<SharedUserModel> {
    const user = auth;
    user.language = navigator.language;
    user.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return of(user);
  }
}
